export default {
  methods: {
    handlePreview() {
      this.imgPreviewVisible = true;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isGIF = file.type === 'image/gif';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error('上传图片限制为 JPG、PNG、GIF 格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return (isJPG || isPNG || isGIF) && isLt5M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handleBeforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    handleHttprequest({file}) {
      let formData = {};
      formData['files'] = file

      this.$q.common.uploadMedia({
        data: formData
      })
      .then(res=>{
        this.form.picList.push({
          name: res.data[0].name,
          url: res.data[0].path,
          fileId: res.data[0].id,
          relationId: this.form.spuCode,
          type: 4
        })
      })
    },
    handleRemove(file) {
      const removeIndex = this.form.picList.findIndex(item => item.name === file.name);
      if (removeIndex > -1) {
        this.form.picList.splice(removeIndex, 1);
      }
    }
  }
}